export const DEFAULT_CRM_TOKEN = 'ea8gl15hsws';
export const AGENCY_ID = 705;
export const brandLogo = `${window.assetsLocation}/images/logo.png`;
export const brandLogoSecondary = `${window.assetsLocation}/images/logo2.png`;
export const brandShowcaseUrl = `${window.assetsLocation}/images/showcase.png`;
export const bannerUrl = `${window.assetsLocation}/images/banner.png`;
export const viewReportIconUrl = `${window.assetsLocation}/images/carousel.png`;
export const twitterXIcon = `${window.assetsLocation}/images/x.svg`;
export const homeArticleIds = ['3'];
export const faqArticleIds = ['4', '5', '6', '7'];
export const portalHomeUrl = 'https://www.apopka.comcate.com/';
export const portalName = 'Apopka Help Center';
